<!--
  vim: tabstop=2:softtabstop=2:shiftwidth=2:expandtab:
-->
<template>
  <div id="app">
    <section class="hero back is-fullheight">
      <div class="hero-body">
        <bmi></bmi>
      </div>
    </section>
  </div>
</template>

<script>
import Bmi from './components/bmi'

export default {
  name: 'app',
  components: {
    Bmi
  }
}
</script>

<style>
@import '../node_modules/bulma/css/bulma.css';
html, body {
  height: 100%;
  margin: 0;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
}
.image {
  max-width: 600px;
  margin: 0 auto;
}
</style>
